// extracted by mini-css-extract-plugin
export var hidden = "styles-module__hidden___I0CFp";
export var textAndBtnContainer = "styles-module__textAndBtnContainer___Mc5Y_";
export var showMoreBtn = "styles-module__showMoreBtn___woWuO";
export var languageContainer = "styles-module__languageContainer___HaMgI";
export var trailDetailItemContainer = "styles-module__trailDetailItemContainer___t6xpF";
export var displayText = "styles-module__displayText___lr7Zp";
export var rowReverse = "styles-module__rowReverse___Wq_01";
export var editButton = "styles-module__editButton___g35Sm";
export var lineClamp = "styles-module__lineClamp___IawHc";
export var editSeoDescriptionCta = "styles-module__editSeoDescriptionCta___Cz84Q";
export var extendedDescription = "styles-module__extendedDescription___QVROS";